'use client';
import React, { useContext, useState, forwardRef } from 'react';
import { Button, Input } from '@/shared/components';
import languageContext from '@/context/language';
import { useTranslation } from '@/app/i18n/client';

interface IProps {
  placeHolderTxt: string;
  onClick?: (e) => void;
  initialValue?: string;
}
const SearchInput = forwardRef<HTMLInputElement, IProps>(function FavoritesTable(props, ref) {
  const { lang } = useContext(languageContext);
  const { t } = useTranslation(lang, 'document-search');
  const { placeHolderTxt, initialValue = '' } = props;
  const [search, setSearch] = useState(initialValue);

  React.useEffect(() => {
    setSearch(initialValue);
  }, [initialValue]);

  const handleSearchEnterKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchboxFunc();
    }
  };
  const searchboxFunc = () => {
    props.onClick(search?.trim());
  };
  return (
    <div className="flex mb-10 sm:inline-flex sm:flex-col w-6/12 sm:w-full md:w-full">
      <div className="relative w-10/12 mr-12 md:mr-4 md:w-2/3 border border-solid border-gray-450 sm:mt-2 sm:w-full flex">
        <Input
          placeholder={placeHolderTxt}
          className="min-w-[250px] c-input--medium w-full text-ellipsis border-0"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          onKeyDown={(e) => {
            handleSearchEnterKey(e);
          }}
        />
        <i
          className=" icon-24-search-mono text-gray-500 absolute right-0 top-1/2 cursor-text"
          style={{ transform: 'translate(-50%, -50%)' }}
        ></i>
      </div>
      <div className="sm:w-full md:ml-auto">
        <Button
          className="ml-auto sm:m-auto sm:flex sm:justify-center sm:w-full sm:p-0 sm:mt-2 min-w-[50px]"
          onClick={searchboxFunc}
          type="outline"
        >
          {t('search')}
        </Button>
      </div>
    </div>
  );
});
export { SearchInput };
